import React, { useEffect, useState } from 'react';
import useUser from 'hooks/useUser';
import { AnswerNetVideoTPVStatusType } from 'modules/types';
import { useGetCurrentTpvStatus } from 'api/agreement';
import { TPVUnverified } from './TPVUnverified';
import { TPVVerified } from './TPVVerified';
import { TPVFailed } from './TPVFailed';

const POLLING_INTERVAL_IN_SECONDS = 5 * 1000;
const BACKOFF_TIME_IN_SECONDS = 30 * 1000;

export function OnboardingTPV() {
  const [tpvStatus, setTpvStatus] = useState<AnswerNetVideoTPVStatusType | undefined>();
  const [pollingInterval, setPollingInterval] = useState(POLLING_INTERVAL_IN_SECONDS);
  const { selectedAgreement, userResult } = useUser();

  useEffect(() => {
    if (!selectedAgreement?.users_tpv_statuses?.length) {
      setTpvStatus(undefined);
      return;
    }

    const status = selectedAgreement?.users_tpv_statuses.find(
      (el: { user_id: string; tpv_status: string }) => el.user_id === userResult?.user?.id,
    );
    setTpvStatus(status?.tpv_status);
  }, [selectedAgreement, userResult]);

  useGetCurrentTpvStatus({
    agreementId: selectedAgreement?.id,
    onSuccess: (data) => {
      if (data.tpv_status !== AnswerNetVideoTPVStatusType.PENDING) {
        window.location.reload();
      } else {
        setPollingInterval(POLLING_INTERVAL_IN_SECONDS);
      }
    },
    onError: () => setPollingInterval(BACKOFF_TIME_IN_SECONDS),
    refetchInterval: pollingInterval,
    tpvStatus,
  });

  switch (tpvStatus) {
    case AnswerNetVideoTPVStatusType.PENDING:
      return <TPVUnverified />;
    case AnswerNetVideoTPVStatusType.FAILED:
      return <TPVFailed />;
    case AnswerNetVideoTPVStatusType.VERIFIED:
      return <TPVVerified />;
    default:
      return <TPVUnverified />;
  }
}

export default OnboardingTPV;
